import ModelMelhousGuideItem from "./ModelMelhousGuideItem";
import ModelMelhousMessage from "./ModelMelhousMessage";
import ModelMelhousRequestType from "./ModelMelhousRequestType";
import ModelMelhousRecommendation from "./ModelMelhousRecommendation";

function getView() {
  return {
    model: "melhous",
    form_action: ["save", "edit"],
    table_action: ["edit"],
    activeSearch: false,
    domain: [],
    softDomain: [["id", ">", 0]],
    fields: {
      title: { type: "char", readOnly: true },
      link_melhous: { type: "char" },
      require_table_qr: { type: "boolean" },
      guide_items: {
        type: "one2many",
        model: "melhous.guide_item",
        layout: ModelMelhousGuideItem.ctxView(),
      },
      messages: {
        type: "one2many",
        model: "melhous.message",
        layout: ModelMelhousMessage.ctxView(),
      },
      request_types: {
        type: "one2many",
        model: "melhous.request_type",
        layout: ModelMelhousRequestType.ctxView(),
      },
      recommendations: {
        type: "one2many",
        model: "melhous.recommendation",
        layout: ModelMelhousRecommendation.ctxView(),
      },
    },
    list: [{ name: "title", width: "40%" }, { name: "require_table_qr" }],
    form: [
      { name: "title" },
      { name: "link_melhous" },
      { name: "require_table_qr" },
      { name: "guide_items" },
      { name: "messages" },
      { name: "request_types" },
      { name: "recommendations" },
    ],
  };
}

export default { ctxView: getView };
